import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Navbar from "../../nav_bar/Navbar";
import Footer from "../../footer/Footer";
import { fetchGrammarTopicById } from "./grammarService";
import "./GrammarTopicDetailPage.css";

const GrammarTopicDetailPage = () => {
 const { id } = useParams();
 const navigate = useNavigate();
 const [topic, setTopic] = useState(null);
 const [loading, setLoading] = useState(true);

 useEffect(() => {
 const load = async () => {
 setLoading(true);
 const res = await fetchGrammarTopicById(id);
 if (res.status === 200 && res.data?.status) {
 setTopic(res.data.data);
 } else {
 }
 setLoading(false);
 };
 load();
 }, [id]);

 if (loading) return (<><Navbar /><div className="gtd-page"><p className="gtd-loading">Loading...</p></div><Footer /></>);
 if (!topic) return (<><Navbar /><div className="gtd-page"><p className="gtd-loading">Topic not found.</p><button className="gtd-back" onClick={() => navigate("/study/grammar")}>← Back</button></div><Footer /></>);

 return (
 <>
 <Navbar />
 <div className="gtd-page">
 <button className="gtd-back" onClick={() => navigate("/study/grammar")}>← Back to Grammar</button>

 <div className="gtd-hero">
 <span className="gtd-icon">{topic.icon || "📘"}</span>
 <h1 className="gtd-title">{topic.title}</h1>
 <p className="gtd-desc">{topic.description}</p>
 </div>

 {(!topic.subTopics || topic.subTopics.length === 0) ? (
 <p className="gtd-loading">No sub-topics available yet.</p>
 ) : (
 <div className="gtd-list">
 {topic.subTopics.map((st, idx) => (
 <div key={st.id} className="gtd-item" onClick={() => navigate(`/study/grammar/sub-topic/${st.id}`)}>
 <div className="gtd-item-num">{idx + 1}</div>
 <div className="gtd-item-info">
 <h3 className="gtd-item-title">{st.title}</h3>
 <span className="gtd-item-sections">{st.sectionCount || 0} sections</span>
 </div>
 <span className="gtd-item-arrow">→</span>
 </div>
 ))}
 </div>
 )}
 </div>
 <Footer />
 </>
 );
};

export default GrammarTopicDetailPage;
